import 'rc-tooltip/assets/bootstrap.css';
import React, { lazy } from 'react';
import { useTranslation } from 'react-i18next';
import InfoStyle from './style';

const layout = window?.$environment?.CURRENT_LAYOUT;

const Label = lazy(() => import(`@/components/UI/Label/${layout}`));
const SvgIcon = lazy(() => import(`@/components/SvgIcon/${layout}`));

const InfoCard = ({
    fleetIconMapping,
    companyName = '',
    totalCount = '0',
}) => {
    const { t } = useTranslation();
    return (
        <InfoStyle>
            <Label className="text">
                {companyName}
            </Label>
            <div class="content">
            <Label className="count">
                {totalCount}
            </Label>
            <div>
                <Label className="label">
                    {t('scorecard.total')}
                </Label>
                <Label className="label">
                    {t('scorecard.vehicle')}
                </Label>
            </div>
           <SvgIcon
                value={
                    fleetIconMapping['infoTruck']
                    ? fleetIconMapping['infoTruck']
                    : 'bobTail'
                }
            />
          </div>
        </InfoStyle>
    );
}

export default InfoCard;
